<template>
  <div class="a-vg-c--bet-placed-modal display-flex" :class="getClassForCurrentState()">
    <image-svg v-if="isImageVisible" :imageName="getImageForCurrentState()"/>
    <span v-else>. . .</span>
    <span>
      {{getMessageByCurrentState()}}
    </span>
    <span v-if="isErrorVisible">
      {{errorMessage}}
    </span>
  </div>
</template>

<script>
// this.currentState
// 1 - accept
// 2 - error
// 3 - loading
import ImageSVG from '@/components/common/ImageSVG.vue'
export default {
  components: {
    'image-svg': ImageSVG
  },
  props: {
    currentState: {
      type: Number,
      required: true
    },
    errorMessage: String
  },
  methods: {
    getImageForCurrentState: function () {
      switch (this.currentState) {
        case 1:
          return 'accept'
        case 2:
          return 'close-app'
        case 3:
          return ''
      }
    },
    getClassForCurrentState: function () {
      switch (this.currentState) {
        case 1:
          return 'success'
        case 2:
          return 'danger'
        case 3:
          return 'loading'
      }
    },
    getMessageByCurrentState: function () {
      switch (this.currentState) {
        case 1:
          return this.$t('vdog_bet_placed')
        case 2:
          return this.$t('vdog_betting_failed')
        case 3:
          return this.$t('vdog_betting_in_progress')
      }
    }
  },
  computed: {
    isImageVisible: function () {
      return this.currentState === 1 || this.currentState === 2
    },
    isErrorVisible: function () {
      return this.errorMessage && this.errorMessage.length > 0
    }
  }
}
</script>
